/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';
import { ContentData, ContentModel } from './content.component-model';

export class BackdropModel extends ContentModel implements ContentData {
  static readonly KEYS = ContentModel.KEYS;

  constructor(data?: ContentData, keys?: string[]) {
    super(data, keys || BackdropModel.KEYS);
  }

  protected setupValues(values: ContentData, exclusive: boolean): ContentData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.BACKDROP;
    }
    return super.setupValues(values, exclusive) as ContentData;
  }

}
